<form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
  <p-card styleClass="w-30rem">
    <ng-template pTemplate="title">
      <i class="fas fa-user-lock"></i> Login
    </ng-template>
    <ng-template pTemplate="content">
      @if (
        messages && messages.length && state.error && state.error.status === 404
      ) {
        <app-alert
          severity="error"
          [header]="error.summary"
          [canToggle]="false"
          styleClass="pt-1 pb-1 px-3"
          [text]="error.detail">
        </app-alert>
      }

      <div class="flex flex-column gap-3">
        <label for="username">Anmeldename</label>
        <input
          type="text"
          id="username"
          formControlName="username"
          pInputText />

        <label for="password">Passwort</label>
        <input
          type="password"
          id="password"
          formControlName="password"
          pInputText />
      </div>
      <p-divider />
      <a
        class="text-sm text-color-secondary flex gap-2 align-items-center no-underline"
        [routerLink]="['/passwort-vergessen']"
        ><i class="fas fa-question-circle"></i>Passwort vergessen?</a
      >
    </ng-template>
    <ng-template pTemplate="footer">
      <p-button
        [loading]="loading"
        [rounded]="true"
        icon="fas fa-unlock"
        label="Login"
        type="submit">
      </p-button>
    </ng-template>
  </p-card>
</form>
